<template>
  <div class="service-center">
    <nav>
      <TopNav />
    </nav>
    <div class="page1">
      <img src="../../assets/image/service.jpg"/>
      <div class="text">
        <div class="left">
          <div class="title">VIP SERVICE</div>
          <div class="title">1V1专业健康顾问团队</div>
          <div class="intro">
            <p>雅致用户服务中心始终秉持以“客户为中心”的服务理念和宗旨,用真心为每一位产后妈妈提供全程贴心、专业的1V1服务。雅致用户服务中心拥有专业的健康顾问团队,每一名健康顾问均通过康复治疗技能与理论考核。健康顾问熟悉掌握产后修复相关医学知识,团队内定期举行医疗知识培训与案例分析,不断提升服务专业能力。</p>
          </div>
        </div>
      </div>
      <div class="contact-wrapper">
        <div class="title">联系我们</div>
        <div class="clear-line"/>
        <div class="contact-box">
          <div class="box-item">
            <div class="box-content">
              <div class="title">全国售后服务热线</div>
              <img class="tel" src="../../assets/image/tel.jpg"/>
              <div class="num">400-633-8080</div>
              <div>服务时间：8:30-12:00</div>
            </div>
          </div>
          <div class="box-item">
            <div class="box-content">
              <div class="title">总部地址</div>
              <img class="tel address" src="../../assets/image/address.jpg"/>
              <div>地址：长沙高新开发区
                岳麓西大道1689号综合楼
                101六楼620房间</div>
            </div>
          </div>
          <div class="box-item">
            <div class="box-content" style="padding: 35px 20px;width: 210px">
              <img class="code" src="../../assets/image/code.png"/>
              <div>微信专业健康顾问<br/>
                打开微信扫一扫识别二维码</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import TopNav from "./components/TopNav.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "ServiceCenter",
  components: {Footer, TopNav}
}
</script>
<style lang="less"  scoped>
.service-center {
  min-height: 100%;
  font-size: 16px;
  background: #ffffff;
  .page1 {
    height: 100%;
    position: relative;
    padding-top: 152px;
    display: flex;
    flex-direction: column;
    img {
      display: block;
      width: 100%;
      flex: 0 0 auto;
    }
    .text {
      width: 50%;
      left: 25%;
      top: 30%;
      margin: 0 auto;
      max-width: 1024px;
      position: absolute;
      .left {
        width: 500px;
        .title {
          font-size: 32px;
          color: #D3AF8B;
        }
        .intro p {
          line-height: 25px;
          font-size: 14px;
          color: #646464;
        }
      }
    }
    .contact-wrapper {
      background: #ffffff;
      padding: 80px 0;
      text-align: center;
      .title {
        font-size: 18px;
      }
      .clear-line {
        width: 20px;
        height: 2px;
        background: #B1B1B1;
        margin: 20px auto 30px;
      }
      .contact-box {
        display: flex;
        flex-direction: row;
        justify-content: center;
        line-height: 24px;
        .box-item {
          padding: 0 20px;
          .box-content {
            background: #f5f5f5;
            width: 190px;
            padding: 35px 30px;
            height: 216px;
            color: #323232;
            text-align: center;
            display: flex;
            flex-direction: column;
            .title {
              font-size: 18px;
            }
            .tel {
              width: 55px;
              margin: 40px auto;
            }
            .address{
              width: 70px;
              margin: 35px auto;
            }
            .code {
              width: 120px;
              margin: 0 auto 40px;
            }
            .num {
              font-size: 24px;
              margin-bottom: 7px;
            }
          }
        }
      }
    }
    .footer {
      background: #c4c4c4;
      flex: 1 1 auto;
      color: #ffffff;
      padding: 50px 0 20px;
      .footer-content {
        width: 830px;
        margin: 0 auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/new/ServiceCenter.vue